import { FC, SVGProps } from 'react';

/**
 * Minimalist menu icon — two thin equal-width lines with rounded caps.
 * Modern, sleek, reads as a refined menu mark (Linear / Notion style).
 */
export const MenuIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    aria-hidden="true"
    {...props}
  >
    <line x1="4" y1="9" x2="20" y2="9" />
    <line x1="4" y1="15" x2="20" y2="15" />
  </svg>
);

export default MenuIcon;
